// Written by index.html's scorer-token script, which runs before anything else can read the address bar.
const STORAGE_KEY = 'advise_scorer_token';

declare global {
  interface Window {
    // The same script's copy for this load, for a storage that refused or was full.
    __adviseScorerToken?: string | null;
    // Set by the same script on the scorer page, which keeps Pendo off it.
    __adviseScorerPage?: boolean;
  }
}

// Storage can be refused or full; the page must still work for this load.
const withStorage = <T>(use: (storage: Storage) => T): T | null => {
  try {
    return use(window.sessionStorage);
  } catch {
    return null;
  }
};

// This load's own link first, since a full storage can still hold an older one.
export const readScorerToken = (): string | null =>
  window.__adviseScorerToken ?? withStorage((storage) => storage.getItem(STORAGE_KEY));

// A link the API refused or closed is never sent again from this tab.
export const clearScorerToken = (): void => {
  window.__adviseScorerToken = null;
  withStorage((storage) => storage.removeItem(STORAGE_KEY));
};
